import { Component, Input } from '@angular/core';
import { CustomFieldModel } from '@base/modules/rest/custom-field/model/custom-field.model';
import { CustomFieldTypesEnum } from '@base/modules/rest/custom-field/enums/custom-field-types.enum';

@Component({
  selector: 'app-field-view',
  templateUrl: './field-view.component.html',
  styleUrls: ['./field-view.component.scss'],
})
export class FieldViewComponent {
  @Input() field: CustomFieldModel;
  @Input() data: any;
  @Input() isInline: boolean;

  CustomFieldTypesEnum = CustomFieldTypesEnum;
}
